import { render, staticRenderFns } from "./ColdStorageTemperature.vue?vue&type=template&id=490cfd8d&scoped=true&"
import script from "./ColdStorageTemperature.vue?vue&type=script&lang=js&"
export * from "./ColdStorageTemperature.vue?vue&type=script&lang=js&"
import style0 from "./ColdStorageTemperature.vue?vue&type=style&index=0&id=490cfd8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490cfd8d",
  null
  
)

export default component.exports